module.exports = [
	"/${lang}/",
	"/${lang}/faq/",
	"/${lang}/about/contributors.html",
	"/${lang}/",
	"/${lang}/faq/",
	"/${lang}/about/contributors.html",
	"/en/about/before-using-vux.html",
	"/en/about/showcase.html",
	"/en/about/thanks.html",
	"/en/changelog/2.7.6.html",
	"/en/changelog/changelog.html",
	"/en/changelog/next.html",
	"/en/changelog/v2.0.0.html",
	"/en/changelog/v2.0.1.html",
	"/en/changelog/v2.0.14.html",
	"/en/changelog/v2.1.0-rc.46.html",
	"/en/changelog/v2.1.0-rc.47.html",
	"/en/changelog/v2.1.0-rc.48.html",
	"/en/changelog/v2.1.0-rc.49.html",
	"/en/changelog/v2.1.0-rc.50.html",
	"/en/changelog/v2.1.0-rc.51.html",
	"/en/changelog/v2.1.0.html",
	"/en/changelog/v2.1.1-rc.1.html",
	"/en/changelog/v2.1.1-rc.10.html",
	"/en/changelog/v2.1.1-rc.11.html",
	"/en/changelog/v2.1.1-rc.12.html",
	"/en/changelog/v2.1.1-rc.13.html",
	"/en/changelog/v2.1.1-rc.14.html",
	"/en/changelog/v2.1.1-rc.2.html",
	"/en/changelog/v2.1.1-rc.3.html",
	"/en/changelog/v2.1.1-rc.4.html",
	"/en/changelog/v2.1.1-rc.5.html",
	"/en/changelog/v2.1.1-rc.6.html",
	"/en/changelog/v2.1.1-rc.7.html",
	"/en/changelog/v2.1.1-rc.8.html",
	"/en/changelog/v2.1.1-rc.9.html",
	"/en/changelog/v2.2.0.html",
	"/en/changelog/v2.2.1-rc.1.html",
	"/en/changelog/v2.2.1-rc.2.html",
	"/en/changelog/v2.2.1-rc.3.html",
	"/en/changelog/v2.2.1-rc.4.html",
	"/en/changelog/v2.2.1-rc.6.html",
	"/en/changelog/v2.2.1-rc.7.html",
	"/en/changelog/v2.2.1-rc.8.html",
	"/en/changelog/v2.2.1.html",
	"/en/changelog/v2.2.2.html",
	"/en/changelog/v2.3.1.html",
	"/en/changelog/v2.3.2.html",
	"/en/changelog/v2.3.3.html",
	"/en/changelog/v2.3.4.html",
	"/en/changelog/v2.3.5.html",
	"/en/changelog/v2.3.6.html",
	"/en/changelog/v2.3.7.html",
	"/en/changelog/v2.3.8.html",
	"/en/changelog/v2.4.0.html",
	"/en/changelog/v2.4.1.html",
	"/en/changelog/v2.5.0.html",
	"/en/changelog/v2.5.1.html",
	"/en/changelog/v2.5.10.html",
	"/en/changelog/v2.5.11.html",
	"/en/changelog/v2.5.12.html",
	"/en/changelog/v2.5.2.html",
	"/en/changelog/v2.5.3.html",
	"/en/changelog/v2.5.4.html",
	"/en/changelog/v2.5.5.html",
	"/en/changelog/v2.5.6.html",
	"/en/changelog/v2.5.7.html",
	"/en/changelog/v2.5.8.html",
	"/en/changelog/v2.5.9.html",
	"/en/changelog/v2.6.0.html",
	"/en/changelog/v2.6.1.html",
	"/en/changelog/v2.6.2.html",
	"/en/changelog/v2.6.3.html",
	"/en/changelog/v2.6.4.html",
	"/en/changelog/v2.6.5.html",
	"/en/changelog/v2.7.0.html",
	"/en/changelog/v2.7.1.html",
	"/en/changelog/v2.7.2.html",
	"/en/changelog/v2.7.3.html",
	"/en/changelog/v2.7.4.html",
	"/en/changelog/v2.7.5.html",
	"/en/changelog/v2.7.6.html",
	"/en/changelog/v2.7.7.html",
	"/en/changelog/v2.7.8.html",
	"/en/changelog/v2.7.9.html",
	"/en/changelog/v2.8.0.html",
	"/en/changelog/v2.8.1.html",
	"/en/changelog/v2.9.0.html",
	"/en/changelog/v2.9.1.html",
	"/en/changelog/v2.9.2.html",
	"/en/changes.html",
	"/en/components_dialog.html",
	"/en/components_form.html",
	"/en/components_layout.html",
	"/en/components.html",
	"/en/contribution/donate.html",
	"/en/contribution/issue.html",
	"/en/contribution/pr.html",
	"/en/contribution/vux-development.html",
	"/en/css.html",
	"/en/css/1px.html",
	"/en/css/close.html",
	"/en/development/i18n.html",
	"/en/development/remove-click-delay-fastclick.html",
	"/en/development/router.html",
	"/en/development/theme.html",
	"/en/development/typescript.html",
	"/en/development/vue-ajax.html",
	"/en/development/vue-global-method.html",
	"/en/development/vue-google-analytics.html",
	"/en/development/vue-loader-autoprefix.html",
	"/en/development/vue-loader-disable-eslint.html",
	"/en/development/vue-router-page-transition.html",
	"/en/development/vue-show-loading.html",
	"/en/development/vue-webpack-code-splitting-async.html",
	"/en/development/vue-webpack-env.html",
	"/en/development/vux-nuxt-ssr.html",
	"/en/directives/v-transfer-dom.html",
	"/en/faq/$t-is-not-defined.html",
	"/en/faq/can-vux-used-in-weapp.html",
	"/en/faq/cannot-resolve-inline-desc.html",
	"/en/faq/difference-between-vux-template-and-webpack-template.html",
	"/en/faq/document-framework.html",
	"/en/faq/does-vux-support-weex.html",
	"/en/faq/dupicate-style.html",
	"/en/faq/index.html",
	"/en/faq/is-vux-wechat-official-project.html",
	"/en/faq/Uncaught-SyntaxError-Unexpected-token-export.html",
	"/en/faq/vux-build-issue.html",
	"/en/faq/vux-server-render-support.html",
	"/en/faq/what-is-vux-virtual-component.html",
	"/en/faq/why-cannot-i-import-all-components.html",
	"/en/faq/why-cannot-i-use-vux-with-cdn.html",
	"/en/faq/why-close-my-issue.html",
	"/en/faq/why-delete-my-issue-comment.html",
	"/en/faq/why-use-vue-file-for-distribution.html",
	"/en/faq/why-use-x-prefix-for-components.html",
	"/en/faq/why-using-vux-loader.html",
	"/en/faq/will-vux-stop-maintaining.html",
	"/en/install/biolerplate.html",
	"/en/install/manual-usage.html",
	"/en/install/npm.html",
	"/en/install/umd.html",
	"/en/install/upgrade-to-vux2.html",
	"/en/install/usage.html",
	"/en/lab/index.html",
	"/en/production/inline-manifest.html",
	"/en/README.html",
	"/en/tools/base64.html",
	"/en/tools/cookie.html",
	"/en/tools/date.html",
	"/en/tools/debounce-throttle.html",
	"/en/tools/md5.html",
	"/en/tools/number.html",
	"/en/tools/querystring.html",
	"/en/tools/string.html",
	"/en/umd.html",
	"/en/upgrade-to-2.html",
	"/en/vux-loader.html",
	"/en/vux-loader/about.html",
	"/en/vux-loader/how-vux-loader-works.html",
	"/en/vux-loader/install.html",
	"/en/vux-loader/plugins.html",
	"/en/wechat/other.html",
	"/en/wechat/vue-wechat-jssdk.html",
	"/en/wechat/wechat-document-title.html",
	"/zh-CN/about/before-using-vux.html",
	"/zh-CN/about/showcase.html",
	"/zh-CN/about/thanks.html",
	"/zh-CN/changelog/2.7.6.html",
	"/zh-CN/changelog/changelog.html",
	"/zh-CN/changelog/next.html",
	"/zh-CN/changelog/v2.0.0.html",
	"/zh-CN/changelog/v2.0.1.html",
	"/zh-CN/changelog/v2.0.14.html",
	"/zh-CN/changelog/v2.1.0-rc.46.html",
	"/zh-CN/changelog/v2.1.0-rc.47.html",
	"/zh-CN/changelog/v2.1.0-rc.48.html",
	"/zh-CN/changelog/v2.1.0-rc.49.html",
	"/zh-CN/changelog/v2.1.0-rc.50.html",
	"/zh-CN/changelog/v2.1.0-rc.51.html",
	"/zh-CN/changelog/v2.1.0.html",
	"/zh-CN/changelog/v2.1.1-rc.1.html",
	"/zh-CN/changelog/v2.1.1-rc.10.html",
	"/zh-CN/changelog/v2.1.1-rc.11.html",
	"/zh-CN/changelog/v2.1.1-rc.12.html",
	"/zh-CN/changelog/v2.1.1-rc.13.html",
	"/zh-CN/changelog/v2.1.1-rc.14.html",
	"/zh-CN/changelog/v2.1.1-rc.2.html",
	"/zh-CN/changelog/v2.1.1-rc.3.html",
	"/zh-CN/changelog/v2.1.1-rc.4.html",
	"/zh-CN/changelog/v2.1.1-rc.5.html",
	"/zh-CN/changelog/v2.1.1-rc.6.html",
	"/zh-CN/changelog/v2.1.1-rc.7.html",
	"/zh-CN/changelog/v2.1.1-rc.8.html",
	"/zh-CN/changelog/v2.1.1-rc.9.html",
	"/zh-CN/changelog/v2.2.0.html",
	"/zh-CN/changelog/v2.2.1-rc.1.html",
	"/zh-CN/changelog/v2.2.1-rc.2.html",
	"/zh-CN/changelog/v2.2.1-rc.3.html",
	"/zh-CN/changelog/v2.2.1-rc.4.html",
	"/zh-CN/changelog/v2.2.1-rc.6.html",
	"/zh-CN/changelog/v2.2.1-rc.7.html",
	"/zh-CN/changelog/v2.2.1-rc.8.html",
	"/zh-CN/changelog/v2.2.1.html",
	"/zh-CN/changelog/v2.2.2.html",
	"/zh-CN/changelog/v2.3.1.html",
	"/zh-CN/changelog/v2.3.2.html",
	"/zh-CN/changelog/v2.3.3.html",
	"/zh-CN/changelog/v2.3.4.html",
	"/zh-CN/changelog/v2.3.5.html",
	"/zh-CN/changelog/v2.3.6.html",
	"/zh-CN/changelog/v2.3.7.html",
	"/zh-CN/changelog/v2.3.8.html",
	"/zh-CN/changelog/v2.4.0.html",
	"/zh-CN/changelog/v2.4.1.html",
	"/zh-CN/changelog/v2.5.0.html",
	"/zh-CN/changelog/v2.5.1.html",
	"/zh-CN/changelog/v2.5.10.html",
	"/zh-CN/changelog/v2.5.11.html",
	"/zh-CN/changelog/v2.5.12.html",
	"/zh-CN/changelog/v2.5.2.html",
	"/zh-CN/changelog/v2.5.3.html",
	"/zh-CN/changelog/v2.5.4.html",
	"/zh-CN/changelog/v2.5.5.html",
	"/zh-CN/changelog/v2.5.6.html",
	"/zh-CN/changelog/v2.5.7.html",
	"/zh-CN/changelog/v2.5.8.html",
	"/zh-CN/changelog/v2.5.9.html",
	"/zh-CN/changelog/v2.6.0.html",
	"/zh-CN/changelog/v2.6.1.html",
	"/zh-CN/changelog/v2.6.2.html",
	"/zh-CN/changelog/v2.6.3.html",
	"/zh-CN/changelog/v2.6.4.html",
	"/zh-CN/changelog/v2.6.5.html",
	"/zh-CN/changelog/v2.7.0.html",
	"/zh-CN/changelog/v2.7.1.html",
	"/zh-CN/changelog/v2.7.2.html",
	"/zh-CN/changelog/v2.7.3.html",
	"/zh-CN/changelog/v2.7.4.html",
	"/zh-CN/changelog/v2.7.5.html",
	"/zh-CN/changelog/v2.7.6.html",
	"/zh-CN/changelog/v2.7.7.html",
	"/zh-CN/changelog/v2.7.8.html",
	"/zh-CN/changelog/v2.7.9.html",
	"/zh-CN/changelog/v2.8.0.html",
	"/zh-CN/changelog/v2.8.1.html",
	"/zh-CN/changelog/v2.9.0.html",
	"/zh-CN/changelog/v2.9.1.html",
	"/zh-CN/changelog/v2.9.2.html",
	"/zh-CN/changes.html",
	"/zh-CN/changes/next_en.html",
	"/zh-CN/changes/next_zh-CN.html",
	"/zh-CN/changes/next.html",
	"/zh-CN/changes/v2.0.0_en.html",
	"/zh-CN/changes/v2.0.0_zh-CN.html",
	"/zh-CN/changes/v2.0.0.html",
	"/zh-CN/changes/v2.0.1_en.html",
	"/zh-CN/changes/v2.0.1_zh-CN.html",
	"/zh-CN/changes/v2.0.1.html",
	"/zh-CN/changes/v2.0.14_en.html",
	"/zh-CN/changes/v2.0.14_zh-CN.html",
	"/zh-CN/changes/v2.0.14.html",
	"/zh-CN/changes/v2.1.0_en.html",
	"/zh-CN/changes/v2.1.0_zh-CN.html",
	"/zh-CN/changes/v2.1.0-rc.46_en.html",
	"/zh-CN/changes/v2.1.0-rc.46_zh-CN.html",
	"/zh-CN/changes/v2.1.0-rc.46.html",
	"/zh-CN/changes/v2.1.0-rc.47_en.html",
	"/zh-CN/changes/v2.1.0-rc.47_zh-CN.html",
	"/zh-CN/changes/v2.1.0-rc.47.html",
	"/zh-CN/changes/v2.1.0-rc.48_en.html",
	"/zh-CN/changes/v2.1.0-rc.48_zh-CN.html",
	"/zh-CN/changes/v2.1.0-rc.48.html",
	"/zh-CN/changes/v2.1.0-rc.49_en.html",
	"/zh-CN/changes/v2.1.0-rc.49_zh-CN.html",
	"/zh-CN/changes/v2.1.0-rc.49.html",
	"/zh-CN/changes/v2.1.0-rc.50_en.html",
	"/zh-CN/changes/v2.1.0-rc.50_zh-CN.html",
	"/zh-CN/changes/v2.1.0-rc.50.html",
	"/zh-CN/changes/v2.1.0-rc.51_en.html",
	"/zh-CN/changes/v2.1.0-rc.51_zh-CN.html",
	"/zh-CN/changes/v2.1.0-rc.51.html",
	"/zh-CN/changes/v2.1.0-rc.52.html",
	"/zh-CN/changes/v2.1.0.html",
	"/zh-CN/changes/v2.1.1-rc.1_en.html",
	"/zh-CN/changes/v2.1.1-rc.1_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.1.html",
	"/zh-CN/changes/v2.1.1-rc.10_en.html",
	"/zh-CN/changes/v2.1.1-rc.10_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.11_en.html",
	"/zh-CN/changes/v2.1.1-rc.11_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.12_en.html",
	"/zh-CN/changes/v2.1.1-rc.12_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.13_en.html",
	"/zh-CN/changes/v2.1.1-rc.13_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.14_en.html",
	"/zh-CN/changes/v2.1.1-rc.14_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.2_en.html",
	"/zh-CN/changes/v2.1.1-rc.2_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.2.html",
	"/zh-CN/changes/v2.1.1-rc.3_en.html",
	"/zh-CN/changes/v2.1.1-rc.3_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.3.html",
	"/zh-CN/changes/v2.1.1-rc.4_en.html",
	"/zh-CN/changes/v2.1.1-rc.4_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.4.html",
	"/zh-CN/changes/v2.1.1-rc.5_en.html",
	"/zh-CN/changes/v2.1.1-rc.5_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.5.html",
	"/zh-CN/changes/v2.1.1-rc.6_en.html",
	"/zh-CN/changes/v2.1.1-rc.6_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.6.html",
	"/zh-CN/changes/v2.1.1-rc.7_en.html",
	"/zh-CN/changes/v2.1.1-rc.7_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.7.html",
	"/zh-CN/changes/v2.1.1-rc.8_en.html",
	"/zh-CN/changes/v2.1.1-rc.8_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.8.html",
	"/zh-CN/changes/v2.1.1-rc.9_en.html",
	"/zh-CN/changes/v2.1.1-rc.9_zh-CN.html",
	"/zh-CN/changes/v2.1.1-rc.9.html",
	"/zh-CN/components_dialog.html",
	"/zh-CN/components_form.html",
	"/zh-CN/components_layout.html",
	"/zh-CN/components.html",
	"/zh-CN/contribution/donate.html",
	"/zh-CN/contribution/issue.html",
	"/zh-CN/contribution/pr.html",
	"/zh-CN/contribution/vux-development.html",
	"/zh-CN/css.html",
	"/zh-CN/css/1px.html",
	"/zh-CN/css/close.html",
	"/zh-CN/demos/actionsheet.html",
	"/zh-CN/demos/alert.html",
	"/zh-CN/demos/badge.html",
	"/zh-CN/demos/blur.html",
	"/zh-CN/demos/button-tab.html",
	"/zh-CN/demos/calendar.html",
	"/zh-CN/demos/card.html",
	"/zh-CN/demos/cell-box.html",
	"/zh-CN/demos/cell-form-preview.html",
	"/zh-CN/demos/cell.html",
	"/zh-CN/demos/check-icon.html",
	"/zh-CN/demos/checker.html",
	"/zh-CN/demos/checklist.html",
	"/zh-CN/demos/clocker.html",
	"/zh-CN/demos/color-picker.html",
	"/zh-CN/demos/confirm.html",
	"/zh-CN/demos/countdown.html",
	"/zh-CN/demos/countup.html",
	"/zh-CN/demos/datetime-range.html",
	"/zh-CN/demos/datetime-view.html",
	"/zh-CN/demos/datetime.html",
	"/zh-CN/demos/divider.html",
	"/zh-CN/demos/drawer.html",
	"/zh-CN/demos/flexbox.html",
	"/zh-CN/demos/flow.html",
	"/zh-CN/demos/form-preview.html",
	"/zh-CN/demos/grid.html",
	"/zh-CN/demos/group.html",
	"/zh-CN/demos/icon.html",
	"/zh-CN/demos/inline-calendar.html",
	"/zh-CN/demos/inline-loading.html",
	"/zh-CN/demos/inline-x-number.html",
	"/zh-CN/demos/load-more.html",
	"/zh-CN/demos/loading.html",
	"/zh-CN/demos/marquee.html",
	"/zh-CN/demos/masker.html",
	"/zh-CN/demos/msg.html",
	"/zh-CN/demos/panel.html",
	"/zh-CN/demos/picker.html",
	"/zh-CN/demos/popover.html",
	"/zh-CN/demos/popup-header.html",
	"/zh-CN/demos/popup-picker.html",
	"/zh-CN/demos/popup-radio.html",
	"/zh-CN/demos/popup.html",
	"/zh-CN/demos/previewer.html",
	"/zh-CN/demos/qrcode.html",
	"/zh-CN/demos/radio.html",
	"/zh-CN/demos/range.html",
	"/zh-CN/demos/rater.html",
	"/zh-CN/demos/scroller.html",
	"/zh-CN/demos/search.html",
	"/zh-CN/demos/selector.html",
	"/zh-CN/demos/spinner.html",
	"/zh-CN/demos/step.html",
	"/zh-CN/demos/sticky.html",
	"/zh-CN/demos/swipeout.html",
	"/zh-CN/demos/swiper.html",
	"/zh-CN/demos/tab.html",
	"/zh-CN/demos/tabbar.html",
	"/zh-CN/demos/timeline.html",
	"/zh-CN/demos/toast.html",
	"/zh-CN/demos/view-box.html",
	"/zh-CN/demos/wechat-emotion.html",
	"/zh-CN/demos/x-address.html",
	"/zh-CN/demos/x-button.html",
	"/zh-CN/demos/x-circle.html",
	"/zh-CN/demos/x-dialog.html",
	"/zh-CN/demos/x-header.html",
	"/zh-CN/demos/x-icon.html",
	"/zh-CN/demos/x-img.html",
	"/zh-CN/demos/x-input.html",
	"/zh-CN/demos/x-number.html",
	"/zh-CN/demos/x-progress.html",
	"/zh-CN/demos/x-switch.html",
	"/zh-CN/demos/x-table.html",
	"/zh-CN/demos/x-textarea.html",
	"/zh-CN/development/i18n.html",
	"/zh-CN/development/remove-click-delay-fastclick.html",
	"/zh-CN/development/router.html",
	"/zh-CN/development/theme.html",
	"/zh-CN/development/typescript.html",
	"/zh-CN/development/vue-ajax.html",
	"/zh-CN/development/vue-global-method.html",
	"/zh-CN/development/vue-google-analytics.html",
	"/zh-CN/development/vue-loader-autoprefix.html",
	"/zh-CN/development/vue-loader-disable-eslint.html",
	"/zh-CN/development/vue-router-page-transition.html",
	"/zh-CN/development/vue-show-loading.html",
	"/zh-CN/development/vue-webpack-code-splitting-async.html",
	"/zh-CN/development/vue-webpack-env.html",
	"/zh-CN/development/vux-nuxt-ssr.html",
	"/zh-CN/directives/v-transfer-dom.html",
	"/zh-CN/faq/$t-is-not-defined.html",
	"/zh-CN/faq/can-vux-used-in-weapp.html",
	"/zh-CN/faq/cannot-resolve-inline-desc.html",
	"/zh-CN/faq/difference-between-vux-template-and-webpack-template.html",
	"/zh-CN/faq/document-framework.html",
	"/zh-CN/faq/does-vux-support-weex.html",
	"/zh-CN/faq/dupicate-style.html",
	"/zh-CN/faq/index.html",
	"/zh-CN/faq/is-vux-wechat-official-project.html",
	"/zh-CN/faq/Uncaught-SyntaxError-Unexpected-token-export.html",
	"/zh-CN/faq/vux-build-issue.html",
	"/zh-CN/faq/vux-server-render-support.html",
	"/zh-CN/faq/what-is-vux-virtual-component.html",
	"/zh-CN/faq/why-cannot-i-import-all-components.html",
	"/zh-CN/faq/why-cannot-i-use-vux-with-cdn.html",
	"/zh-CN/faq/why-close-my-issue.html",
	"/zh-CN/faq/why-delete-my-issue-comment.html",
	"/zh-CN/faq/why-use-vue-file-for-distribution.html",
	"/zh-CN/faq/why-use-x-prefix-for-components.html",
	"/zh-CN/faq/why-using-vux-loader.html",
	"/zh-CN/faq/will-vux-stop-maintaining.html",
	"/zh-CN/install/biolerplate.html",
	"/zh-CN/install/manual-usage.html",
	"/zh-CN/install/npm.html",
	"/zh-CN/install/umd.html",
	"/zh-CN/install/upgrade-to-vux2.html",
	"/zh-CN/install/usage.html",
	"/zh-CN/lab/index.html",
	"/zh-CN/production/inline-manifest.html",
	"/zh-CN/README.html",
	"/zh-CN/tools/base64.html",
	"/zh-CN/tools/cookie.html",
	"/zh-CN/tools/date.html",
	"/zh-CN/tools/debounce-throttle.html",
	"/zh-CN/tools/md5.html",
	"/zh-CN/tools/number.html",
	"/zh-CN/tools/querystring.html",
	"/zh-CN/tools/string.html",
	"/zh-CN/umd.html",
	"/zh-CN/upgrade-to-2.html",
	"/zh-CN/vux-loader.html",
	"/zh-CN/vux-loader/about.html",
	"/zh-CN/vux-loader/how-vux-loader-works.html",
	"/zh-CN/vux-loader/install.html",
	"/zh-CN/vux-loader/plugins.html",
	"/zh-CN/wechat/other.html",
	"/zh-CN/wechat/vue-wechat-jssdk.html",
	"/zh-CN/wechat/wechat-document-title.html",
	"/en/components/actionsheet.html",
	"/en/components/alert.html",
	"/en/components/badge.html",
	"/en/components/blur.html",
	"/en/components/box.html",
	"/en/components/button-tab.html",
	"/en/components/calendar.html",
	"/en/components/card.html",
	"/en/components/cell-box.html",
	"/en/components/cell-form-preview.html",
	"/en/components/cell.html",
	"/en/components/check-icon.html",
	"/en/components/checker.html",
	"/en/components/checklist.html",
	"/en/components/clocker.html",
	"/en/components/color-picker.html",
	"/en/components/confirm.html",
	"/en/components/countdown.html",
	"/en/components/countup.html",
	"/en/components/datetime-range.html",
	"/en/components/datetime-view.html",
	"/en/components/datetime.html",
	"/en/components/divider.html",
	"/en/components/drawer.html",
	"/en/components/flexbox.html",
	"/en/components/flow.html",
	"/en/components/form-preview.html",
	"/en/components/grid.html",
	"/en/components/group.html",
	"/en/components/icon.html",
	"/en/components/inline-calendar.html",
	"/en/components/inline-desc.html",
	"/en/components/inline-loading.html",
	"/en/components/inline-x-number.html",
	"/en/components/inline-x-switch.html",
	"/en/components/load-more.html",
	"/en/components/loading.html",
	"/en/components/marquee.html",
	"/en/components/masker.html",
	"/en/components/msg.html",
	"/en/components/panel.html",
	"/en/components/picker.html",
	"/en/components/popover.html",
	"/en/components/popup-header.html",
	"/en/components/popup-picker.html",
	"/en/components/popup-radio.html",
	"/en/components/popup.html",
	"/en/components/previewer.html",
	"/en/components/qrcode.html",
	"/en/components/radio.html",
	"/en/components/range.html",
	"/en/components/rater.html",
	"/en/components/scroller.html",
	"/en/components/search.html",
	"/en/components/selector.html",
	"/en/components/spinner.html",
	"/en/components/step.html",
	"/en/components/sticky.html",
	"/en/components/swipeout.html",
	"/en/components/swiper.html",
	"/en/components/tab.html",
	"/en/components/tabbar.html",
	"/en/components/timeline.html",
	"/en/components/toast.html",
	"/en/components/v-chart.html",
	"/en/components/view-box.html",
	"/en/components/wechat-emotion.html",
	"/en/components/x-address.html",
	"/en/components/x-button.html",
	"/en/components/x-circle.html",
	"/en/components/x-dialog.html",
	"/en/components/x-header.html",
	"/en/components/x-icon.html",
	"/en/components/x-img.html",
	"/en/components/x-input.html",
	"/en/components/x-number.html",
	"/en/components/x-progress.html",
	"/en/components/x-switch.html",
	"/en/components/x-table.html",
	"/en/components/x-textarea.html",
	"/zh-CN/components/actionsheet.html",
	"/zh-CN/components/alert.html",
	"/zh-CN/components/badge.html",
	"/zh-CN/components/blur.html",
	"/zh-CN/components/box.html",
	"/zh-CN/components/button-tab.html",
	"/zh-CN/components/calendar.html",
	"/zh-CN/components/card.html",
	"/zh-CN/components/cell-box.html",
	"/zh-CN/components/cell-form-preview.html",
	"/zh-CN/components/cell.html",
	"/zh-CN/components/check-icon.html",
	"/zh-CN/components/checker.html",
	"/zh-CN/components/checklist.html",
	"/zh-CN/components/clocker.html",
	"/zh-CN/components/color-picker.html",
	"/zh-CN/components/confirm.html",
	"/zh-CN/components/countdown.html",
	"/zh-CN/components/countup.html",
	"/zh-CN/components/datetime-range.html",
	"/zh-CN/components/datetime-view.html",
	"/zh-CN/components/datetime.html",
	"/zh-CN/components/divider.html",
	"/zh-CN/components/drawer.html",
	"/zh-CN/components/flexbox.html",
	"/zh-CN/components/flow.html",
	"/zh-CN/components/form-preview.html",
	"/zh-CN/components/grid.html",
	"/zh-CN/components/group.html",
	"/zh-CN/components/icon.html",
	"/zh-CN/components/inline-calendar.html",
	"/zh-CN/components/inline-desc.html",
	"/zh-CN/components/inline-loading.html",
	"/zh-CN/components/inline-x-number.html",
	"/zh-CN/components/inline-x-switch.html",
	"/zh-CN/components/load-more.html",
	"/zh-CN/components/loading.html",
	"/zh-CN/components/marquee.html",
	"/zh-CN/components/masker.html",
	"/zh-CN/components/msg.html",
	"/zh-CN/components/panel.html",
	"/zh-CN/components/picker.html",
	"/zh-CN/components/popover.html",
	"/zh-CN/components/popup-header.html",
	"/zh-CN/components/popup-picker.html",
	"/zh-CN/components/popup-radio.html",
	"/zh-CN/components/popup.html",
	"/zh-CN/components/previewer.html",
	"/zh-CN/components/qrcode.html",
	"/zh-CN/components/radio.html",
	"/zh-CN/components/range.html",
	"/zh-CN/components/rater.html",
	"/zh-CN/components/scroller.html",
	"/zh-CN/components/search.html",
	"/zh-CN/components/selector.html",
	"/zh-CN/components/spinner.html",
	"/zh-CN/components/step.html",
	"/zh-CN/components/sticky.html",
	"/zh-CN/components/swipeout.html",
	"/zh-CN/components/swiper.html",
	"/zh-CN/components/tab.html",
	"/zh-CN/components/tabbar.html",
	"/zh-CN/components/timeline.html",
	"/zh-CN/components/toast.html",
	"/zh-CN/components/v-chart.html",
	"/zh-CN/components/view-box.html",
	"/zh-CN/components/wechat-emotion.html",
	"/zh-CN/components/x-address.html",
	"/zh-CN/components/x-button.html",
	"/zh-CN/components/x-circle.html",
	"/zh-CN/components/x-dialog.html",
	"/zh-CN/components/x-header.html",
	"/zh-CN/components/x-icon.html",
	"/zh-CN/components/x-img.html",
	"/zh-CN/components/x-input.html",
	"/zh-CN/components/x-number.html",
	"/zh-CN/components/x-progress.html",
	"/zh-CN/components/x-switch.html",
	"/zh-CN/components/x-table.html",
	"/zh-CN/components/x-textarea.html"
];


//////////////////
// WEBPACK FOOTER
// ./src/routes.json
// module id = 300
// module chunks = 630